import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDnqfEeYAwHXgPcdQIiRG8Uom1harUUGMg",
  authDomain: "hobi-hub.firebaseapp.com",
  projectId: "hobi-hub",
  storageBucket: "hobi-hub.firebasestorage.app",
  messagingSenderId: "148955052338",
  appId: "1:148955052338:web:7f3d7d1f983bc94d917f2b",
  measurementId: "G-D2TXQTKS2M"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;
